import axios from "axios";
import URLS from "../modules/util/urls.js";

const state = {

}

const mutations = {

}

const actions = {
  listarCaracteristicasImovel(context, payload) {
    return axios.post(URLS.CARACTERISTICAS_IMOVEL_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch("listarCaracteristicasImovel", payload);
            }
          }).catch((error) => {
            throw error;
          });
      }
    }).catch((error) => {
      throw error;
    });
  },

  listarCaracteristicasCondominio(context, payload) {
    return axios.post(URLS.CARACTERISTICAS_CONDOMINIO_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch("listarCaracteristicasCondominio", payload);
            }
          }).catch((error) => {
            throw error;
          });
      }
    }).catch((error) => {
      throw error;
    });
  }
}

export default {
  state,
  mutations,
  actions
}